import { Identifier, randomUUID } from "../id";
export class POrderLineId extends Identifier {
    constructor() {
        super("POrderLineId", randomUUID());
    }
}
